import productApi from "@/service/modules/productApi"
import { Image } from "antd"
import { useEffect, useState } from "react"
import Link from 'next/link'

export default function MidBanner() {
  const [bannerInfo, setBannerInfo] = useState({
    imageUrl: "",
    target: "",
    url: ""
  })

  useEffect(() => {
    getMinitopBanner()
  }, [])

  const getMinitopBanner = async () => {
    try {
      const res = await productApi.minitopBanner()
      setBannerInfo(res.data)
    } catch (error: any) {
      console.log(error);
    }
  }

  return (
    <>
      {
        bannerInfo.imageUrl
        &&
        <div style={{ maxWidth: '100%', marginTop: '16px' }}>
          <Link
            href={bannerInfo.url}
            target={bannerInfo.target}
            passHref
            legacyBehavior
          >
            <a rel="noopener noreferrer" target={bannerInfo.target} style={{ display: "block", userSelect: 'none' }}>
              <Image
                src={bannerInfo.imageUrl}
                width={"100%"}
                alt={"mid-banner"}
                preview={false}
              />
            </a>
          </Link>
        </div>
      }
    </>
  )
}